declare global {
  interface Window { RDCF_FEATURES: string[]; }
}
import notifcationService from 'data/notification';
import _ from 'lodash';

const API = process.env.API;

async function get() {
  if (!window.RDCF_FEATURES) {
    let data = await(await fetch(`${API}features`)).json()
    data = await checkAppCues(data)
    window.RDCF_FEATURES = data;
  }
}

async function checkAppCues(data) {
  if (!data.includes('appcues')) return data
  if (window.AppcuesWidget) return data
  if (
    !localStorage.RDCF_NEXT_FEATURE_WARNING || Date.now() > localStorage.RDCF_NEXT_FEATURE_WARNING
  ) {
    setTimeout(
      () =>
        notifcationService.notify({
          type: 'warn',
          message:
            'Automated walkthrough unavailable.\nCheck whether your security settings block appcues.com',
          dismiss: 5000
        }),
      1000
    )
    delete localStorage.RDCF_NEXT_FEATURE_WARNING
  }
  if (!localStorage.RDCF_NEXT_FEATURE_WARNING) {
    localStorage.RDCF_NEXT_FEATURE_WARNING = Date.now() + 12 * 60 * 60 * 1000
  }
  return data.filter(d => d != 'appcues')
}

export default {
  automaticPropertyUpgrade: function () {
    return window.RDCF_FEATURES.includes('automaticPropertyUpgrade')
  },
  caProp13TaxLineItemState: function () {
    return window.RDCF_FEATURES.includes('caProp13TaxLineItemState')
  },
  displayAEExport: function () {
    return window.RDCF_FEATURES.includes('ae-export')
  },
  displayAppCues: function () {
    return window.RDCF_FEATURES.includes('appcues')
  },
  displayAssetManagement: function() {
    return window.RDCF_FEATURES.includes("asset-management")
  },
  displayAssetManagementV1: function() {
    return window.RDCF_FEATURES.includes("asset-management-v1")
  },
  displayValuationSettings: function () {
    return window.RDCF_FEATURES.includes('valuationSettings')
  },
  displayChargebee: function () {
    return window.RDCF_FEATURES.includes('chargebee')
  },
  displayComparisons: function() {
    return window.RDCF_FEATURES.includes('comparisons')
  },
  displayOldPropertyAuditLog: function () {
    return window.RDCF_FEATURES.includes('old-property-auditlog')
  },
  displayBIExport: function () {
    return window.RDCF_FEATURES.includes('biexport')
  },
  displayFolderAuditLog: function () {
    return window.RDCF_FEATURES.includes('folder-audit-log')
  },
  displayMixedUse: function () {
    return window.RDCF_FEATURES.includes('mixed-use')
  },
  displayMultifamily: function () {
    return window.RDCF_FEATURES.includes('multifamily-rent-roll')
  },
  displayHospitality: function() {
    return window.RDCF_FEATURES.includes('hospitality')
  },
  displayFolderExplorer: function () {
    return window.RDCF_FEATURES.includes('new-folder-explorer')
  },
  displayFolderReports: function () {
    return window.RDCF_FEATURES.includes('folder-reports')
  },
  displayNewCalc: function() {
    return window.RDCF_FEATURES.includes("display-new-calc")
  },
  displayNewMFLineItems: function() {
    return window.RDCF_FEATURES.includes("mf-line-items-rewrite")
  },
  displayNewNamedRecoveries: function() {
    return window.RDCF_FEATURES.includes("named-recoveries-rewrite")
  },
  displayNewPropList: function() {
    return window.RDCF_FEATURES.includes("propListRewrite")
  },
  displayNewRenewalProbability: function() {
    return window.RDCF_FEATURES.includes("renewal-probability-rewrite")
  },
  displayNewDowntime: function() {
    return window.RDCF_FEATURES.includes("downtime-rewrite")
  },
  displayNewTenantMarket: function() {
    return window.RDCF_FEATURES.includes("tenant-market-rewrite")
  },
  displayNewMarketLease: function () {
    return window.RDCF_FEATURES.includes("market-lease-rewrite")
  },
  displayNewRentRoll: function() {
    return window.RDCF_FEATURES.includes("new-rent-roll")
  },
  displayNewUserAdmin: function(){
    return window.RDCF_FEATURES.includes("users-user-groups")
  },
  displayNewVacancyCredit: function () {
    return window.RDCF_FEATURES.includes("vacancy-credit-rewrite")
  },
  displayVTSImport: function() {
    return window.RDCF_FEATURES.includes("display-vts-import")
  },
  displayOktaLogin: function () {
    return window.RDCF_FEATURES.includes("okta-login")
  },
  displayRentRollReports: function() {
    return window.RDCF_FEATURES.includes("rent-roll-reports")
  },
  includeReorderInHistory: function () {
    return window.RDCF_FEATURES.includes('include-reorder-in-history')
  },
  displayNewInflation: function () {
    return window.RDCF_FEATURES.includes("inflation-rewrite")
  },
  replaceByFolderIdChange: function () {
    return window.RDCF_FEATURES.includes('replaceByFolderIdChange')
  },
  allowMultifamilyUW: function () {
    return window.RDCF_FEATURES.includes('multifamily-underwriting')
  },
  clearTokenOnMissingProfile: function () {
    return window.RDCF_FEATURES.includes('login-issue--clear-token-on-missing-profile')
  },
  enabledMultifamilyOnly: function () {
    return window.RDCF_FEATURES.includes('multifamily-only-license')
  },
  permissions: function () {
    return window.RDCF_FEATURES.includes('permissions-2022')
  },
  propertyTemplates: function () {
    return window.RDCF_FEATURES.includes('property-templates')
  },
  throttleRequests: function () {
    return _.includes(window.RDCF_FEATURES, 'throttle-client-requests')
  },
  displayPropertyCreateHelpers: function () {
    return _.includes(window.RDCF_FEATURES, 'property-create-helper-fields')
  },
  calcVersionSelector: function() {
    return window.RDCF_FEATURES.includes('calc-version-selector')
  },
  validationRefactor: function() {
    // return window.RDCF_FEATURES.includes('validation-am-refactor')
    return false
  },
  multiselect: function() {
    return window.RDCF_FEATURES.includes('multiselect')
  },
  notifications: function() {
    return window.RDCF_FEATURES.includes('notifications')
  },
  globalToolTips: function() {
    return window.RDCF_FEATURES.includes('global-tooltip')
  },
  useRouterForSidebarLinks: function() {
    return window.RDCF_FEATURES.includes('use-router-for-sidebar-links')
  },
  get
}